<ng-template #addstandarduser>
  <div id="acceptDiv">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Edit User</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">X</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="addUserForm" autocomplete="off">
        <div class="form-group">

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <div class="profilepic">
                  <img #profilePic src="{{userInputModel.ProfilePicPath}}">
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  First Name
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" formControlName="txtFirstName" [readonly]="true" [(ngModel)]="userInputModel.FirstName" placeholder="First Name" autocomplete="off" maxlength="30" dropSpecialCharacters="false" class="form-control" required>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Last Name
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" formControlName="txtLastName" [readonly]="true" [(ngModel)]="userInputModel.LastName" placeholder="Last Name" autocomplete="off" maxlength="30" dropSpecialCharacters="false" class="form-control" required>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Email
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" [readonly]="true" (change)="validateemail()" autocomplete="off" maxlength="100" formControlName="txtEmail" [(ngModel)]="userInputModel.EmailAddress" class="form-control" required>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">Property<span class="star">*</span></label>
                <div class="select-dropdown  multiselectdesign multiselect-check-all select-check">
                   <mat-form-field  >
                    
                    <mat-select placeholder="Select Property" [(ngModel)]="propertyIdsToAdd"
                                formControlName="lstRole"
                                multiple (click)="addClassToOverlayContainer();">
                                @if (propertyIdsToAdd?.length > 1) {
                                  <mat-select-trigger>
                                    <span>{{ propertyIdsToAdd?.length }} items selected</span>
                                  </mat-select-trigger>
                                }    
                                  <!-- Search Option -->
                                  <mat-option>
                                    <ngx-mat-select-search
                                        #searchKey
                                        [disableInitialFocus]="true"
                                        [hideClearSearchButton]="true"
                                        placeholderLabel="Search here"
                                        noEntriesFoundLabel="Nothing found..."
                                        [enableClearOnEscapePressed]="true"
                                    ></ngx-mat-select-search>
                                  </mat-option>
                                <!-- Select/Unselect All Options -->
                                <mat-option class="select-all-option hide-checkbox">
                                  <div class="d-flex justify-content-between">
                                    <span class="select-all-text" (click)="$event.stopPropagation(); selectAllProperty()">
                                      <i class="fa fa-check"></i> Select All
                                    </span>
                                    <span class="select-all-text" (click)="$event.stopPropagation(); unselectAllProperty()">
                                      <i class="fa fa-times"></i> Unselect All
                                    </span>
                                  </div>
                                </mat-option>
                      @for (property of propertyList| arraySearch : 'name' : searchKey.value; track property) {
                        <mat-option [value]="property.id" class="multi-dropdown-item">{{property.name}}</mat-option>
                      }
                      @if (propertyList.length === 0) {
                        <mat-option class="matoptionnodata" disabled>
                          Nothing found...
                        </mat-option>
                      }
                    </mat-select>
                    
                  </mat-form-field>
                  <div *ngIf="lstRole && ((lstRole.invalid && isSubmitted )||(lstRole.invalid && (lstRole.dirty || lstRole.touched)))">
                    <p class="redtext" *ngIf="lstRole.errors.required">
                      {{ addPropertyValidation }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Phone
                  <span class="star">*</span>
                </label>
                <div>
                  <input class="form-control" formControlName="txtPhone" required [readonly] ="true" [(ngModel)]="userInputModel.PhoneNumber" mask='(000) 000-0000' type="text" maxlength="20">
                </div>
              </div>
            </div>

          </div>

          <!--<div class="form-group">
              <textarea class="form-control textarea-min-height" maxlength="4000"  required type="text" placeholder="Please enter comments"></textarea>
              <p class="redtext">Please enter comments </p>
          </div>-->
          <div class="text-right">
            <button class="btn btn-default btn-lg" id="closeModal" (click)="onClose()">Cancel</button>
            <button type="button" (click)="saveUser()" class="btn btn-success btn-lg">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<div class="innerpage-fullwithbanner">
  <h2 class="bighead">{{userDetailsOutput.FirstName}} {{userDetailsOutput.LastName}}</h2>
  <ul class="bread-crumbs">
    <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li *ngIf="this.authService.Admin()||this.authService.SuperAdmin()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li><a href="#" [routerLink]="['/market-snapshot']" [queryParams]="{ UserGuid: PrincipalUserGuid,opentab: '6'}">Access Controls<span>|</span></a></li>
    <li>User Detail</li>
  </ul>
</div>
<div class="section-margin">
    <div class="container container-lg min-heightcontainer">
        <div class="border-div margin0">

            <div class="tabstyle2 offerdetailstab-padding pos-relative" *ngIf="userDetailsOutput.UserRoleId !== 7">
              <ul class="switchingproperty margin-bottom-15 offerlistingtab">
                <li [class.active]="activeTab === tab.PersonalInformation">
                  <a (click)="onTabClick(tab.PersonalInformation)">
                    Profile
                  </a>
                </li>
                <li [class.active]="activeTab === tab.ActivityLog">
                  <a (click)="onTabClick(tab.ActivityLog)">
                    Activity Log
                  </a>
                </li>
               
              </ul>
            </div>
            <div [hidden]="activeTab !== tab.PersonalInformation">
              <div class="floatinghead floatinghead-xs clearfix">
                <h2 class="mainhead"><span class="text">Personal Information</span></h2>
                <button class="right-btn btn  btn-circle btn-green adduserbtn" (click)="editUser(addstandarduser, 'addstandardusermodal');" href="#" placement="left" tooltip="Edit user" ng-reflect-tooltip="Edit" ng-reflect-placement="top"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></button>
              </div>
              <div class="leftsideprofile">
                <div class="profilepic">
                  <img src="{{userDetailsOutput.ProfilePicPath}}">
                </div>
              </div>
              <div class="rightsideprofile">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                      <label class="form-label">First name</label>
                      <h6 class="displayvalue">{{userDetailsOutput.FirstName}}</h6>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                      <label class="form-label">Last Name</label>
                      <h6 class="displayvalue">{{userDetailsOutput.LastName}}</h6>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                      <label class="form-label">Email</label>
                      <h6 class="displayvalue">{{userDetailsOutput.Email ? userDetailsOutput.Email :'-'}}</h6>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                      <label class="form-label">Phone</label>
                      <h6 class="displayvalue">{{userDetailsOutput.Phoneno ? (userDetailsOutput.Phoneno | phone) : '-'}}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="margin-top-30">
                <div class="table-responsive">
                  <table class="table basictable">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Properties with Access</th>
                        <th>Status</th>
                        <th>Recent Activity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let field of properties;let i = index">
                        <td><p>{{i+1}}</p></td>
                        <td>
                          <p><b>{{field.DisplayName}}</b>{{field.Address}}</p>
                        </td>
                        <td>
                          <p>{{field.Status}}</p>
                        </td>
                        <td>
                          <p>{{field.RecentActivity| date:'MM/dd/yyyy' }}</p>
                        </td>
                        
                      </tr>
                    <tfoot>
                      <tr *ngIf="properties?.length == 0 ">
                        <td colspan="9" class="odd no-data-available">
                          <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Data Available</p>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div class="clearfix" *ngIf="activeTab === tab.ActivityLog">
                <div class="col-md-12">
                    <app-audit-trail [propertyView]="true" [User]="User" [propertyIdList] = "propertyIds" [IsDisplayUser]="1" [previousRoute]="prevPage" [isPrincipal] ="true"></app-audit-trail>
                </div>
            </div>

            <!--<div class="text-right">
                <button class="btn btn-lg btn-green" (click)="viewAuditTrail();">{{viewOrHideLabel}} Activity Log</button>
            </div>-->
            <!--<div *ngIf="isViewAuditTrail">
                <app-audit-trail [objectId]="auditObjectId" [objectTypeId]="auditObjectTypeId"></app-audit-trail>
            </div>-->

        </div>


    </div>
</div>
